import { render, staticRenderFns } from "./AccountRule.vue?vue&type=template&id=48ecba47&"
import script from "./AccountRule.vue?vue&type=script&lang=js&"
export * from "./AccountRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports